import { SvgIcon as MuiSvgIcon } from "@material-ui/core";
import { ComponentProps } from "react";
import { Color } from "../../theme/color";

export function OpenInNewIcon(props: ComponentProps<typeof MuiSvgIcon>) {
  return (
    <MuiSvgIcon viewBox="0 0 16 17" htmlColor={Color.Body} {...props}>
      <path d="M3.548 14.392q-.504 0-.855-.35a1.16 1.16 0 0 1-.35-.855V4.264q0-.506.35-.855.351-.35.855-.35h3.705q.213 0 .357.143a.48.48 0 0 1 .143.357q0 .212-.143.356a.48.48 0 0 1-.357.144H3.548a.2.2 0 0 0-.14.064.2.2 0 0 0-.065.14v8.924q0 .077.064.14.065.065.141.065h8.923a.2.2 0 0 0 .142-.064.2.2 0 0 0 .064-.141V9.482q0-.213.143-.357a.48.48 0 0 1 .357-.143q.212 0 .356.143a.48.48 0 0 1 .144.357v3.705q0 .505-.35.855t-.856.35zm9.129-9.63L6.84 10.596a.48.48 0 0 1-.348.142.47.47 0 0 1-.355-.142.48.48 0 0 1-.145-.351q0-.207.145-.352l5.836-5.835h-2.13a.48.48 0 0 1-.357-.144.48.48 0 0 1-.144-.356q0-.213.144-.357a.48.48 0 0 1 .356-.143h3.834v3.833q0 .213-.144.356a.48.48 0 0 1-.356.144.48.48 0 0 1-.357-.144.48.48 0 0 1-.143-.356z" />
    </MuiSvgIcon>
  );
}
export default OpenInNewIcon;
